export default __webpack_public_path__ + "static/media/Hide.9f312624.svg";